export default {
  administrator: 0,
  contributors: 1,
  authenticated: 2,
}
